import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  '@global': {
    '.MuiAutocomplete-option': {
      color: theme.palette.gray.efesGrayish,
      height: 44,
      fontSize: 16,
    },
  },
  option: {
    '&[data-focus="true"]': {
      background: theme.palette.white.efesBackgroundLight,
    },
    '&[aria-selected="true"]': {
      background: 'transparent',
      color: 'inherit',
    },
  },
  autocompleteRoot: {
    '& .MuiAutocomplete-inputRoot': {
      padding: 4,
    },
  },
  inputLabel: {
    transform: 'translate(14px, 12px) scale(1)',
  },
  paper: {
    border: `1px solid ${theme.palette.gray.efesGray}`,
    boxShadow: `0px 20px 20px ${theme.palette.gray.boxShadow}`,
    backgroundColor: theme.palette.white.main,
    marginBottom: 8,
    marginLeft: 2,
  },
  icon: {
    color: theme.palette.black.main,
  },
}));

export default useStyles;
